export default {
  titles: {
    encoding: 'Encodage',
    inbound: 'Entrant',
    user_info: 'Informations utilisateur',
    settings: 'Paramètres',
    reset_daily_items: 'Réinitialiser les articles quotidiens ?',
    last_parcels: 'Derniers colis',
    select_item: 'Sélectionner un article',
    select_workstation: 'Sélectionner un poste de travail',
    select_language: 'Sélectionner une langue',
    support: 'Support',
    select_printer: 'Sélectionner une imprimante',
    shipment_to_confirm: 'Expédition à confirmer',
    sorting_details: 'Détails de ventilation',
    inventories: 'Inventaires',
    pin_modal: "Entrez le code PIN pour forcer l'association",
    shipments: 'Expéditions',
    parcels: 'Emballer',
    //moncler
    outbound_bthp: 'Certificat de sortie BTHP'
  },
  simple_parcel_list: {
    to_read: 'À lire',
    ok: 'Ok',
    force: 'Forcer',
    force_parcel: 'Forcer le colis {{code}}',
    force_parcel_desc: 'Insérez le code PIN utilisateur pour forcer le colis',
    forced: 'Forcé',
    unexpected: 'Inattendu',
    remove: 'Supprimer',
    invalid_pin: 'Code PIN utilisateur invalide'
  },
  create_parcel_gate: {
    //moncler
    width: 'Largeur',
    height: 'Hauteur',
    depth: 'Profondeur',
    tare: 'Tare',
    description: 'Description'
  },
  fields: {
    current_location: 'Emplacement actuel',
    identified_item: 'Article identifié',
    ignored_items: 'Articles ignorés',
    ignored_with_reason_items: 'Articles ignorés avec raison',
    error_items: 'Articles en erreur',
    warning_items: 'Articles en avertissement',
    umg: 'Umg',
    custom_class: 'Classe personnalisée',
    product_code: 'Code produit',
    as400username: "Nom d'utilisateur AS400",
    item_components: 'Composants',
    creation_date: 'Date de création',
    sender: 'Expéditeur',
    year: 'Année',
    number: 'Numéro',
    row: 'Ligne',
    entity: 'Entité',
    labels: 'Étiquettes'
  },
  misc: {
    select_an_option: 'Sélectionner une option...',
    not_set: 'Non défini',
    current_value: 'Valeur actuelle',
    pleaseWait: 'Veuillez patienter...',
    not_associated: 'Non associé',
    replaced: 'Remplacé',
    production_order_info: 'Infos Ordre de production',
    reel_info: 'Infos bobine',
    reel_code: 'Code Bobine',
    assigned_supplier: 'Fournisseur désigné',
    type: 'Type',
    identifier_info: 'Identifiant Info',
    identifier_events: "Identifiant d'événements",
    or: 'ou',
    select_place: `Bonjour {{user}}, sélectionnez votre lieu d\'origine pour continuer`,
    back: 'Retour',
    refresh: 'Rafraîchir',
    reload: 'Recharger',
    save: 'Enregistrer',
    confirm: 'Confirmer',
    confirm_auto: 'Auto-confirmer',
    update_and_confirm: 'Mettre à jour et confirmer',
    update: 'Mettre à jour',
    no_carton_found: 'Aucun carton trouvé',
    confirm_continue: 'Confirmer et continuer',
    cancel: 'Annuler',
    close: 'Fermer',
    user: 'Utilisateur',
    workstation: 'Poste de travail',
    username: "Nom d'utilisateur",
    name: 'Nom',
    password: 'Mot de passe',
    login: 'Connexion',
    encoding: 'Encodage',
    code: 'Code',
    ean_code: 'Code EAN',
    certilogo: 'Certilogo',
    enter_the_necessary_fields: "Entrez les champs nécessaires pour démarrer l'opération",
    associated_items: 'Articles associés',
    associate: 'Associer',
    associated: 'Associé',
    verify: 'Vérifier',
    verify_association: 'Vérifier',
    reading: 'Lecture',
    processing: 'Traitement',
    association: 'Association',
    associations: 'Associations',
    waiting: 'En attente',
    writing: 'Écriture',
    writing_progress: 'Écriture en cours...',
    partial_confirm: 'Confirmation partielle',
    retry: 'Réessayer',
    writing_association: 'Écriture et association',
    confirmed: 'Confirmé',
    unable_to_write: `Impossible d\'écrire l\'étiquette EPC : {{code}} pour le produit : {{productCode}}`,
    unable_to_get_next_epc: `Impossible d\'obtenir l\'EPC suivant pour : {{productCode}}`,
    unable_to_connect_to_workstation: 'Impossible de se connecter au poste de travail',
    tag_info: "Informations sur l'étiquette",
    inbound: 'Entrant',
    outbound: 'Sortant',
    stop: 'Arrêter',
    start: 'Démarrer',
    pause: 'Pause',
    clear: 'Effacer',
    tag_encoded_today: "Étiquette encodée aujourd'hui",
    transaction_date: 'Date de transaction',
    select_transaction_date: 'Sélectionner la date de transaction',
    ready_to_receive: 'Prêt à recevoir',
    change_password: 'Changer le mot de passe',
    logout: 'Déconnexion',
    are_you_sure_to_logout: 'Voulez-vous vraiment vous déconnecter ?',
    settings: 'Paramètres',
    roles: 'Rôles',
    role: 'Rôle',
    email: 'Email',
    place: 'Lieu',
    items: 'Articles',
    description: 'Description',
    color: 'Couleur',
    size: 'Taille',
    part: 'Partie',
    total_reads: 'LECTURES TOTALES',
    total_ok: 'TOTAL OK',
    save_to_list: 'Enregistrer dans la liste',
    destination: 'Destination',
    origin: 'Origine',
    new_parcel: 'Nouveau colis',
    status: 'Statut',
    parcel: 'Colis',
    read_parcel: 'Lire le colis',
    parcels: 'Colis',
    shipment: 'Expédition',
    creation_date: 'Date de création',
    search: 'Rechercher',
    select_search: 'Rechercher...',
    detail: 'Détail',
    quantity: 'Quantité ({{quantity}})',
    only_quantity: 'Quantité',
    style: 'Style',
    material: 'Matériau',
    shipment_code_auto: "Code d'expédition (auto)",
    parcel_code_auto: 'Code de colis (auto)',
    next: 'Suivant',
    parcels_to_receive: 'Colis à recevoir',
    confirm_parcel: 'Confirmer le colis',
    image_missing: 'IMAGE MANQUANTE',
    image: 'Image',
    loading: 'Chargement...',
    unknown_product: 'Produit inconnu',
    unknown_tag: 'Étiquette inconnue',
    invalid_tag: 'Étiquette invalide',
    virgin_tag: 'Étiquette vierge',
    tag_not_associated: 'Étiquette non associée',
    killed: 'Désactivé',
    stock: 'Stock',
    valid: 'Valide',
    unknown: 'Inconnu',
    actions: 'Actions',
    reprint: 'Réimprimer',
    product: 'Produit',
    product_items: 'Articles du produit',
    identifiers: 'Identifiants',
    zone: 'Zone',
    location: 'Emplacement',
    report_repair: 'Signaler une réparation',
    reason: 'Raison',
    request_code_change: 'Demander une modification du code',
    enable_workstation_emulation: "Activer l'émulation du poste de travail",
    enable_browser_print_emulation: "Activer l'émulation du Browser Print",
    filter: 'Filtrer',
    language: 'Langue',
    warning: 'Avertissement',
    success: 'Succès',
    info: 'Info',
    checklist: 'Liste de contrôle',
    optional: 'Optionnel',
    phone: 'Téléphone',
    version: 'Version',
    printer: 'Imprimante',
    new_shipment: 'Nouvelle expédition',
    upc: 'UPC',
    model_part_color_size: 'Modèle / Partie / Couleur / Taille',
    confirm_shipment: "Confirmer l'expédition",
    receive: 'Recevoir',
    delete: 'Supprimer',
    delete_association: 'Supprimer',
    change: 'Modifier',
    from: 'De',
    to: 'À',
    ignored: 'Ignoré',
    skipped: 'Sauté',
    ignored_with_reason: 'Ignoré avec raison',
    yes: 'Oui',
    no: 'Non',
    model: 'Modèle',
    typology: 'Typologie',
    no_result: 'Aucun résultat',
    expected: 'Attendu',
    expected_plural: 'Attendus',
    read: 'Lu',
    missing: 'Manquant',
    unexpected: 'Inattendu',
    unexpected_parcel: 'Colis inattendu',
    ignored_plural: 'Ignorés',
    serial: 'Numero de série',
    priority: 'Priorité',
    group: 'Groupe',
    required_quantity: 'Quantité requise',
    sorted_quantity: 'Quantité ventilée',
    missing_quantity: 'Quantité manquante',
    barcode: 'Code-barres',
    barcode_bc: 'Code-barres BC',
    sorted_date: 'Date de ventilation',
    customer: 'Nom du client',
    list: 'Liste',
    list_position: 'Position dans la liste',
    select_date: 'Sélectionner une date',
    item_info: "Informations sur l'article",
    item_identifier_info: "Informations sur l'identifiant de l'article",
    item_identifier_events: "Événements de l'identifiant de l'article",
    item_events: "Événements de l'article",
    operation_type: "Type d'opération",
    operation_place: "Lieu d'opération",
    loading_data: 'Veuillez patienter, chargement des données...',
    empty_item_events: 'Aucun événement trouvé',
    show_more: 'Afficher plus',
    hide_more: 'Masquer',
    production_order: 'Ordre de production',
    production_order_detail: "Détail de l'ordre de production",
    production_order_row: 'Ligne de production',
    production_order_sku: "SKU de l'ordre de production",
    kill_tag: "Désactiver l'étiquette",
    replace_tag: 'Replace Tag',
    replace_tag_with: 'Replace tag with {{tag}}',
    item_po: "Ordre d'article",
    item_order: "Commande d'article",
    item_row: "Ligne d'article",
    pack_code: 'Code du colis',
    send_reads: 'Envoyer les lectures',
    items_add_inventory_success: "Articles ajoutés à l'inventaire",
    new: 'Nouveau',
    confirm_mission: 'Confirmer la mission',
    confirm_mission_text: 'Êtes-vous sûr de vouloir confirmer la mission ?',
    parziali: 'Partiel',
    total_quantity: 'Quantité totale',
    accepted_quantity: 'Quantité acceptée',
    country_check: 'Contrôle du pays',
    showcase_check: 'Contrôle de vitrine',
    attention: 'Attention',
    clear_items: 'Cette action supprimera toutes les lectures, voulez-vous continuer ?',
    add_partial: 'Attention',
    add_partial_text: "Il peut être nécessaire de créer une mission d'Assurance Qualité",
    add_partial_already_text:
      "Il peut être nécessaire de créer une mission d'Assurance Qualité. UMG a déjà travaillé. Voulez-vous écraser les articles lus ?",
    error_cq_mission: 'Attention, créez une mission pour le contrôle qualité',
    warning_zone_items: 'DANS_UNE_AUTRE_ZONE',
    internal_tag: 'Étiquette interne',
    external_tag: 'Étiquette externe',
    error_tag: 'Étiquette en erreur',
    awaiting: 'En attente',
    error_logs: "Journaux d'erreur",
    event_logs: "Journaux d'événements",
    box_closed: 'Boîte fermée',
    box_out: 'Boîte de sortie',
    unexpected_list: "Liste d'articles inattendus",
    pending_tags: 'Étiquettes en attente',
    selected_zone: 'Zone sélectionnée',
    pricing: 'Tarification',
    send_to_sap: 'Envoyer à SAP',
    write_tag: "Écrire l'étiquette",
    identifier_tag: "Étiquette d'identification",
    digit_identifier_tag: "Saisir l'étiquette à écrire",
    target_epc: 'EPC cible',
    retry_write_tag: "Une erreur d'écriture a été rencontrée. Voulez-vous essayer d'écrire l'étiquette à nouveau ?",
    ready: 'Prêt',
    offline: 'Hors ligne',
    shipping_date: "Date d'expédition",
    update_only_product: "Article déjà associé à un autre produit. Êtes-vous sûr de vouloir l'écraser ?",
    update_production_order_row:
      "Article déjà associé à une autre ligne de commande de production. Êtes-vous sûr de vouloir l'écraser ?",
    export: 'Exporter',
    select_zone: 'Sélectionner une zone',
    location_origin: "Emplacement d'origine",
    confirm_kill_tag: "Confirmer la désactivation de l'étiquette",
    kill_in_progress: 'Killing tags in progress',
    confirm_replace_tag: 'Which tags do you want to Replace?',
    replace_in_progress: 'Replacing tags in progress',
    select_tag_to_kill: "Sélectionnez l'étiquette que vous souhaitez désactiver",
    disassociating_item: 'Article dissocié',
    killing_tag: 'Tuer la balise {{type}} avec le rôle {{role}}',
    retry_kill_tag:
      "Une erreur de suppression a été rencontrée. Voulez-vous essayer de désactiver l'étiquette à nouveau ?",
    reading_tag: 'Tag de lecture',
    writing_tag: 'Écrire des tag',
    writing_tag_with: 'Écrire des tag {{tag}}',
    navBackWarning:
      'Êtes-vous sûr de vouloir revenir en arrière ? Toutes les modifications non enregistrées seront perdues.',
    ready_to_read: 'Prêt à lire',
    remove_product_readings: 'Supprimer les lectures du produit',
    ok: 'OK',
    already_in_parcel: 'déjà dans le colis',
    operation_canceled_by_user: "Opération annulée par l'utilisateur",
    load_more: 'chargement en cours',
    input: 'Insérer',
    rfid_barcodes: 'Codes-barres RFID',
    submit: 'Envoyer',
    //valentino
    error: 'Errore',
    OK_WORKER: 'OK FORNITORE',
    KO_WORKER: 'KO FORNITORE',
    OK_REPAIR: 'OK RIPARAZIONE',
    OK_VALDAGNO: 'OK VALDAGNO',
    KO_VALDAGNO: 'KO VALDAGNO',
    RESO_RICHIESTO_CQ: 'RICHIESTO CQ',
    RESO_OK: 'RESO OK',
    SECOND_VALDAGNO: 'SECONDA SCELTA',
    OK_LINING: 'OK FODERA',
    OK_RISC: 'RISCHIATO',
    KO_LINING: 'KO FODERA',
    size_color: 'Taglia/Colore',
    select_size_color: 'Seleziona taglia/colore',
    print: 'Stampa',
    missings: 'Mancanti',
    embedded: 'Embedded',
    ignoreds: 'Ignorati',
    select_printer: 'Seleziona stampante',
    printing_started: 'Stampa avviata',
    release_reports: 'Verbali di sblocco',
    quality_checks: 'Controlli qualità',
    quality_check: 'Controllo qualità',
    total_mission_qty: 'Qta totale missione',
    inbound_read_qty: 'Qta letta ingresso varco',
    checked_qty: 'Qta controlli effettuati',
    checked: 'Collaudati',
    returned: 'Rientrati',
    damaged: 'Difetti',
    qty_damaged_first_check: 'Qta difettati 1° controllo',
    first_check_date: 'Data 1° controllo',
    qty_damaged_second_check: 'Qta difettati 2° controllo',
    second_check_date: 'Data 2° controllo',
    note: 'Note',
    work_order: 'Work Order',
    order_type: 'Order type',
    //louis vuitton
    start_and_read: 'Veuillez démarrer les antennes et placer le produit',
    advanced_emulation: 'Advanced Emulation',
    emulation_history: 'Emulation History',
    emulation_favorites: 'Favorites',
    power: 'Power',
    sensitivity: 'Sensitivity',
    expected_quantity: 'Attendue',
    extra_quantity: 'Extra',
    encoded_quantity: 'Encodé',
    clear_and_restart: 'Effacer & Redémarrer',
    apply: 'Appliquer',
    products: 'Produits',
    last_paired_sn: 'Dernier SN emparejé',
    last_confirmed_ucs: 'Dernier UCS confirmé',
    user_manual: 'Manuel utilisateur',
    operation_user_manual: "Manuel utilisateur de l'opération",
    activity: 'Activité',
    encodings: 'Encodages',
    progress: 'Progrès',
    encoding_user: "Utilisateur d'encodage",
    encoding_place: "Lieu d'encodage",
    total_encodings: "Total des encodages",
    sizes: 'Tailles'
  },
  error: {
    error: 'Erreur',
    errors: 'Erreurs',
    forbidden: 'Interdit',
    not_found: 'Non trouvé',
    product_not_found: 'Produit non trouvé',
    unauthorized: 'Non autorisé',
    too_many_tags_read: "Trop d'étiquettes lues (attendues {{expected}}, lues {{read}})",
    too_many_checklist_types:
      'Trop de types de check-list. Assurez-vous de sélectionner des colis avec le même type de check-list.',
    rfid_discrepancies_found:
      'Des divergences RFID ont été trouvées, effacez tout et réessayez ou confirmez avec divergences',
    certilogo_not_found: 'Certilogo "{{code}}" non trouvé',
    ean_not_found: 'EAN "{{code}}" non trouvé',
    production_order_not_found: 'Ordre de production "{{code}}" non trouvé',
    no_inbound_zones: "Aucune zone d'entrée",
    no_operation_config: "Configuration de l'opération non trouvée",
    not_supported_reading_mode: 'Mode de lecture non pris en charge',
    undefined_operation_config: "La configuration de l'opération ne peut pas être indéfinie",
    certilogo_already_encoded: 'Certilogo "{{code}}" déjà encodé',
    tag_not_found: 'Étiquette non trouvée',
    missing_printer_id: "Adresse IP de l'imprimante manquante",
    tag_unassociated: 'Étiquette non associée',
    tag_type_unexpected: "Type d'étiquette inattendu",
    tag_already_associated: "Étiquette déjà associée. Vous devez d'abord la dissocier",
    tags_not_associated: 'Une ou plusieurs étiquettes ne sont pas associées',
    tags_mismatch: 'Incohérence des étiquettes',
    workstation_could_not_be_started: "Le poste de travail {{code}} n'a pas pu être démarré",
    antenna_was_started: "L'antenne {{code}} a été démarrée",
    antenna_was_not_started: "L'antenne {{code}} n'a pas été démarrée",
    authentication_failed: "Échec de l'authentification",
    field_required: 'Le champ {{label}} est requis',
    unable_to_connect_to_rfid_reader: "Impossible de se connecter au lecteur RFID. Vérifiez que l'appareil est allumé.",
    items_in_error_found: 'Erreur trouvés sur des articles',
    item_not_in_inbound: 'Article non présent en entrée',
    item_not_in_stock: 'Article non en stock',
    item_in_another_parcel: 'Article dans un autre colis',
    item_in_another_production_order: 'Article dans un autre ordre de production',
    connection: 'Erreur de connexion',
    connection_details: 'Aucune réponse du serveur. Vérifiez que votre connexion Internet ou votre VPN fonctionne.',
    field_invalid_default: 'Valeur par défaut "{{defaultValue}}" invalide pour le champ {{field}}',
    field_invalid: 'Valeur invalide pour le champ {{field}}',
    field_invalid_default_from_endpoint: 'Impossible de trouver une valeur pour le champ {{field}}',
    sorting_already_read: 'Article avec numéro de série {{serial}} déjà lu dans le groupe {{group}}',
    sorting_no_group: 'Article non triable',
    sorting_not_in_zone: 'Article avec numéro de série {{serial}} non triable. Déjà dans la zone {{zone}}',
    sorting_unknown: 'Étiquette {{tag}} non valide',
    sorting_unexpected: 'Étiquette inattendue',
    no_item_configuration: "Aucune configuration d'article trouvée",
    item_creation_error: "Erreur de création d'article",
    couldn_find_production_order: "Impossible de trouver l'ordre de production",
    couldn_find_work_order: 'Impossible de trouver la commande',
    couldn_find_production_order_row: "Impossible de trouver la ligne de l'ordre de production",
    missing_operation_option: "Option d'opération manquante : {{error}}",
    item_session_list_create: 'Liste non créée',
    item_session_list_create_session: 'Session de liste non créée',
    item_session_list_confirm: 'Liste non confirmée',
    item_session_list_confirm_session: 'Session de liste non confirmée',
    form_validation: 'Validation du formulaire',
    form_validation_message: 'Erreur dans le remplissage du champ',
    select_place_error: "Impossible d'enregistrer le lieu d'origine",
    self_user_data: "Impossible d'enregistrer vos données",
    encoding_no_tags: "Aucune autre étiquette n'a été lue. Opération annulée",
    timeout_no_reads: "Aucun tag/ordre de production détecté. Rapprochez le produit de l'antenne et redémarrez",
    only_virgin_tag: 'Seules des étiquettes vierges détectées',
    tags_mismatch_error: 'Veuillez lire une étiquette à la fois',
    tags_mismatch_workorder: 'Discordance de ligne workorder',
    tags_errors: "Erreurs d'étiquettes",
    value_not_valid: "La valeur entrée n'est pas valide",
    write_tag: "Erreur inconnue lors de l'écriture de l'étiquette",
    WRONG_PRODUCTION_ORDER: 'Ordre de production incorrect',
    WRONG_PLACE: 'Mauvais emplacement',
    PRODUCTION_ORDER_ROW_CREATION_ERROR: "Erreur de création de ligne d'ordre de production",
    force_tag_associated: 'Étiquette déjà associée. Réassocier ?',
    operation_confirm_error: "Erreur lors de la confirmation de l'opération",
    missing_mandatory_qc: 'Aucun contrôle qualité. Continuer ?',
    wrong_qc_status: 'Le produit a été déclaré KO. Continuer ?',
    wrong_qc_size: 'Vérifier la taille. Continuer ?',
    wrong_qc_size_payload:
      'Vérifier la taille. Taille encodée : {{productSize}} - Taille physique : {{manualSize}}. Continuer ?',
    wrong_qc_model: 'Vérifier le modèle. Continuer ?',
    start_checklist: 'Check-list non démarrée',
    confirm_with_unexpected: 'Impossible de confirmer avec des étiquettes inattendues',
    confirm_with_overqty: 'Impossible de confirmer avec des étiquettes en trop',
    rfid_reader_initialization: "Erreur inconnue lors de l'initialisation du lecteur RFID",
    remove_sap_item_error: "Impossible de supprimer l'article",
    no_asn_selected: 'Aucun ASN sélectionné',
    submit_asn: "Erreur lors de la soumission de l'ASN",
    zbpNotFound:
      "Agent Zebra Browser Print introuvable sur votre système. Assurez-vous qu'il est installé et en cours d'exécution",
    no_printer_selected: 'Aucune imprimante sélectionnée',
    zplTemplateNotDefined:
      "Modèle ZPL non défini. Veuillez définir un code de modèle dans l'attribut 'zpl-template-code' de la configuration de l'opération",
    no_print_template: "Modèle d'impression introuvable",
    wrong_tag: 'Mauvaise étiquette',
    tag_error_or_not_authentic: "Étiquette non authentique ou erreur d'authentification",
    authentication_timeout: "Délai d'authentification dépassé",
    tid_missing: "Tid manquant pour l'étiquette lue",
    on_destination: 'à destination {{destination}}',
    item_not_sortable: 'Article avec numéro de série {{serial}} non triable',
    search_error: 'Erreur de recherche',
    no_parcel_found_by_identifier: 'Aucun colis trouvé avec ces identifiants',
    kill_tag_not_allowed:
      "Il est impossible de désactiver une étiquette associée à un article. Pour la désactiver, dissociez d'abord l'article.",
    kill_already_killed: 'Balise déjà supprimée',
    can_kill_only_tag_type: 'Vous ne pouvez tuer que les tags {{type}}',
    replace_tag_not_allowed: 'You can only replace tags associated with an article',
    kill_tag_not_success: "Échec de la désactivation de l'étiquette",
    replace_tag_not_success: 'Replace tag failed',
    nfc_tag_not_expected: 'Étiquette NFC non attendue pour ce produit',
    ventilation_quantity_reached: 'La quantité à ventiler pour ce produit a déjà été atteinte',
    confirm_not_allowed_with_errors: "Confirmation non autorisée en présence d'erreurs",
    close_not_allowed_with_errors: "Fermeture non autorisée en présence d'erreurs",
    be_generic_error: 'Erreur système',
    be_generic_error_description: "Une erreur générique s'est produite sur le système.",
    gs1code_invalid: 'Le code GS1 est invalide',
    productionorderrow_mismatch: 'Incompatibilité de la ligne de commande de production. Continuer tout de même ?',
    exceeded_quantity: 'Quantité dépassée',
    production_order_completed: "L'ordre de fabrication est terminé",
    work_order_completed: 'La commande est terminée',
    production_order_row_completed: "La ligne de l'ordre de fabrication est complétée",
    work_order_row_completed: 'La ligne de la commande est complétée',
    replace_tag_not_allowed_for_this_tag: "Il n'est pas possible de remplacer ce type de balise",
    box_already_received: 'Boîte déjà reçue. Lecture inutile.',
    MISSING_EAN_ATTRIBUTE: 'EAN non trouvé pour le produit {{productCode}}',
    other_production_order: 'Déjà associé à une commande de production et produit différent',
    workorder_mismatch:
      "SKU PRODUIT non correspondant à celui indiqué sur le packaging - Vérifiez que le PRODUIT sur le packaging est correct et procédez à l'association"
  },
  messages: {
    no_operations_found: 'Aucune opération trouvée. Vérifiez les permissions utilisateur dans le ControlPanel',
    not_allowed_operation: `Vous n'avez pas l'autorisation d'effectuer cette opération. Veuillez vérifier votre configuration`,
    no_workstations_found: 'Aucun poste de travail trouvé',
    no_workstation_selected: 'Aucun poste de travail sélectionné',
    are_you_sure_to_reset_daily_items: 'Êtes-vous sûr de vouloir réinitialiser les articles quotidiens ?',
    bring_an_item_to_antenna: "Approchez un article de l'antenne",
    press_start_to_read: 'Appuyez sur le bouton Démarrer pour \ncommencer la lecture des produits RFID',
    reading_in_progress: 'Lecture en cours',
    waiting_for_product: 'En attente du produit...',
    paste_comma_separeted_tags: 'Collez des étiquettes séparées par des virgules puis appuyez sur Entrée...',
    connection_workstation_progress: 'Connexion au poste de travail en cours...',
    operation_success: 'Opération confirmée avec succès',
    outbound_success: 'Expédition confirmée avec succès',
    inbound_success: 'Entrée confirmée avec succès',
    pack_success: 'Emballage confirmé avec succès',
    transfer_to_zone_success: 'Transfert vers la zone confirmé avec succès',
    simple_item_list_success: "Liste simple d'articles confirmée avec succès",
    list_empty: 'La liste est vide',
    looks_like_anything_in_list: "On dirait que vous n'avez rien dans votre liste",
    generic_success: '{{code}} confirmé avec succès',
    generic_success_canceled: '{{code}} annulé avec succès',
    generic_error: 'Erreur {{code}}',
    fill_all_fields_and_search_an_item_configuration:
      "Remplissez tous les champs et recherchez une configuration d'article",
    encoding_success: 'Encodage confirmé avec succès',
    encoding_success_none: 'Article déjà associé précédemment',
    read_some_identifier_to_start_verification: 'Lisez un identifiant pour commencer la vérification',
    warning_items_found: 'Avertissement trouvés sur des articles',
    are_you_sure_you_want_to_confirm: 'Êtes-vous sûr de vouloir confirmer ?',
    item_session_list_confirm: 'Liste confirmée avec succès',
    operation_in_progress: 'Opération en cours, veuillez patienter...',
    sorting_error_zones: "Zone d'origine non renseignée, impossible de continuer la ventilation",
    connection_in_progress: 'Connexion en cours...',
    checklist_there_are: 'Il y a',
    checklist_missings: 'articles manquants',
    checklist_overqty: 'articles en excès',
    checklist_unexpecteds: 'articles inattendus',
    checklist_confirm_mismatch_question: 'Êtes-vous sûr de vouloir confirmer quand même ?',
    force_update_content: "Êtes-vous sûr de vouloir forcer l'envoi à SAP ?",
    connection_to_station_in_progress: 'Connexion à la station en cours',
    tag_killed: 'Étiquette désactivée',
    tag_replaced: 'Tag replaced',
    tag_deleted: 'Étiquette supprimée',
    write_tag: 'Étiquette écrite avec succès',
    not_ready: 'Non prêt',
    readyf: 'Prêt',
    nfcDecryption: "Déchiffrement NFC. Veuillez maintenir l'étiquette immobile",
    parcel_success: 'Colis confirmé avec succès',
    sentry: {
      success: 'Thank you for your feedback! Your contribution helps us improve our service.'
    },
    confirm_force_shipment: 'Confirm shipment with PFAS',
    input_rfid_barcodes: 'Saisissez les codes-barres RFID, séparés par une virgule ou un saut de ligne',
    are_you_sure_to_clear_reads: 'Are you sure to clear reads?',
    are_you_sure_to_confirm: 'Are you sure to confirm?',
    inbound_conveyor_confirm_missing_message: 'There are still -missing- items to confirm, are you sure to confirm?',
    update_available: 'Mise à jour disponible',
    update_available_description: 'Une nouvelle version est disponible. Rechargez la page pour mettre à jour.',
    newVersionAvailable: 'Nouvelle version disponible',
    pageWillReload: 'La page se rechargera automatiquement dans 30 secondes',
    deviceManagerUpdateTitle: 'Device Manager Update',
    deviceManagerUpdateDescription:
      'Une nouvelle mise à jour du Device Manager est disponible. Installez-la maintenant pour garantir des performances optimales du lecteur RFID.',
    deviceManagerUpdating:
      'Le Device Manager est en cours de mise à jour. Veuillez patienter - cela peut prendre jusqu’à 5 minutes.',
    deviceManagerUpdateCompleted: 'Update completed successfully',
    deviceManagerUpdateCompletedAndRequiresReboot:
      'La mise à jour s’est terminée avec succès. Veuillez redémarrer votre PC pour appliquer les modifications.',
    exceeded_quantity_message:
      'La quantité pour la ligne de commande de production a été atteinte. Assurez-vous de modifier la ligne ou la commande de production.',
    empty_production_order: "Aucune ligne présente dans l'ordre de fabrication",
    empty_production_order_search: "Aucune ligne d'ordre de fabrication ne correspond à la recherche effectuée",
    areYouSureYouWantToDelete: 'Êtes-vous sûr de vouloir supprimer ?',
    scan_tag_or_insert_code: 'Scannez le tag ou insérez le code',
    no_results: 'Aucun résultat',
    no_more_results: 'Plus de résultats'
  },
  placeholder: {
    search_shipment_parcel: 'Rechercher une expédition ou un colis',
    search_product_parcel: 'Rechercher un produit ou un colis'
  },
  confirm: {
    discrepancy_title: 'Colis avec divergences',
    discrepancy_message:
      'Des produits avec des divergences ont été trouvés. Êtes-vous sûr de vouloir confirmer le colis ?',
    confirm_delete_association: "Êtes-vous sûr de vouloir supprimer cette association d'article ?",
    confirm_delete_operation_title: 'Supprimer {{operation}}',
    confirm_delete_operation: "Voulez-vous supprimer l'opération ? Tous les articles lus seront perdus.",
    confirm_delete_item_association: "Êtes-vous sûr de vouloir supprimer cette association d'article ?",
    confirm_kill_tag: "Êtes-vous sûr de vouloir désactiver l'étiquette {{tag}} ?",
    confirm_multiple_kill_tag: 'Are you sure you want to kill all tags?',
    confirm_disassociate_kill_tag: 'Are you sure you want to disassociate and kill {{type}} tag {{tag}}?',
    confirm_disassociate_multiple_kill_tag: 'Are you sure you want to disassociate and kill all tags?',
    confirm_operation_title: 'Confirmer {{operation}}',
    confirm_operation_text: "Voulez-vous confirmer l'opération ?",
    confirm_operation_text_irreversible: "Voulez-vous confirmer l'opération ? Cette action est irréversible.",
    confirm_operation_text_partial_confirm: 'Envoi de la lecture vers JDE. Êtes-vous sûr de vouloir continuer ?',
    confirm_operation_text_partial_confirm_without_jde: 'Êtes-vous sûr de vouloir continuer ?',
    post_confirm_action_title: 'Continuer',
    post_confirm_action_keep_input: 'Opération terminée. Effectuer une autre opération ?',
    post_confirm_action_change_input: 'Opération terminée. Effectuer une autre opération ?',
    confirm_close_asn_title: 'Confirmation de clôture',
    confirm_close_asn_text:
      "Certains colis n'ont pas été reçus. Êtes-vous sûr de vouloir FORCER la clôture de cette expédition?",
    unpack: 'Colis déjà emballé. Voulez-vous procéder au déballage et à un nouvel emballage?',
    last_parcel_confirmerd: "J'ai confirmé tous les colis de l'expédition {{code}}. Fermer l'expédition aussi?"
  },
  labels: {
    draft: 'Brouillon',
    ready_to_send: 'Prêt à envoyer',
    send_await: "En attente d'envoi",
    outbound_error: "Erreur d'expédition",
    sent: 'Envoyé',
    in_inbound: "En cours d'entrée",
    receive_await: 'En attente de réception',
    ready_to_receive: 'À recevoir',
    inbound_error: "Erreur d'entrée",
    received: 'Reçu',
    in_transit: 'En transit'
  },
  serverError: {
    WRONG_ITEM_SUPPLIER: 'Certains articles lus ne peuvent pas être pris en charge par le fournisseur.',
    QUANTITY_MISMATCH_ERROR: 'Les quantités saisies ne correspondent pas aux quantités détectées.',
    ZONE_MISMATCH_ERROR: 'La zone saisie ne correspond pas à la zone détectée.'
  },
  error_messages: {
    password_required: 'Le champ mot de passe est obligatoire',
    invalid_password: 'Mot de passe invalide',
    missing_workstation_place: 'Missing workstation place',
    connection_in_progress_title: 'Désolé, la connexion a échoué',
    connection_in_progress_text: 'Veuillez réessayer plus tard'
  },
  report_tbox: {
    umg: 'Umg',
    ddt_number: 'DDT N.',
    creation_date: 'Date',
    capi_mdc: 'Capi MDC',
    qt_totale: 'Quantité totale',
    qt_accettata: 'Quantité acceptée',
    qt_scartata: 'Quantité rejetée',
    supplier: 'Fournisseur',
    notes: 'Remarques'
  },
  custom: {
    countTBoxParcel: 'Colis',
    countTBoxDDT: 'DDT',
    BARCODE_READ: 'Lecture du code-barres',
    RFID_START_READING: 'Démarrer la lecture',
    RFID_STOP_READING: 'Arrêter la lecture',
    RESULT_EVENT: 'Événement de résultat',
    TRACE: 'Trace',
    INFO: 'Info',
    WARNING: 'Avertissement',
    ERROR: 'Erreur',
    deleteSession: 'Supprimer le colis',
    deleteSessionMessage: 'Êtes-vous sûr de vouloir supprimer le colis ?',
    deleteList: 'Supprimer le DDT',
    deleteListMessage: 'Êtes-vous sûr de vouloir supprimer le DDT ?',
    WAM: 'SKU',
    sap_warning: 'Avertissement SAP',
    total_list: 'Liste totale',
    total_parcel: 'Colis total',
    order_number: 'Numéro de commande',
    addon: 'Supplément',
    componentType: 'Type de composant',
    //moncler
    confirm_force_received_text: 'La livraison a déjà été confirmée. Souhaitez-vous la supprimer de la liste ?',
    confirm_force_received_sap_text:
      'The shipment has already been received on SAP. Would you like to remove it from the list?',
    confirm_force_received_partially_sap_text:
      'The shipment has already been PARTIALLY received. Please complete it on SAP. Would you like to remove it from the list?',
    //louis vuitton
    tooManyTags: "Trop d'étiquettes",
    nfcDetectedPleaseUseProductControl:
      'Étiquette NFC détectée. Veuillez utiliser la fonctionnalité de contrôle produit.',
    GENERIC_ERROR: 'Erreur - Veuillez contacter le support via ContactIS',
    ECERTIFICATE_WORKORDER_NOT_FOUND: "Il n'y a pas de numéro d'OF lié à ce numéro UCS *{parcelCode} dans eCertificate",
    ITEM_IN_ANOTHER_PARCEL: 'Cet article est déjà déclaré dans un autre colis UCS *{parcelCode}',
    ECERTIFICATE_WORKORDER_CREATED_BOT_NOT_COMPLETED: "Le numéro d'OF dans eCertficate a été créé mais pas complété",
    INVALID_TIMESTAMP: 'Timestamp invalide',
    INVALID_SERIAL: 'Numéro de série invalide',
    INVALID_WORKORDER: "Numéro d'OF invalide",
    INVALID_SKU: 'SKU invalide',
    INVALID_PARCEL_NUMBER: 'Numéro de colis UCS invalide',
    SAP_UCS_NOT_CONFIRMED: 'UCS non confirmé en fin de ligne',
    SAP_REMOVABLE_SYNCHRO_NOT_PERFORMED: 'Synchro amovible non effectuée',
    SAP_INCORRECT_OPERATION_STATUS: "Le status de l'opération de l'UCS *{parcelCode} n'est pas correct dans SAP ME",
    SAP_COMPLETED_NOT_FOUND_IN_TNT: 'UCS déjà complété dans SAP, non présent dans T&T',
    SAP_UCS_CANNOT_BE_COMPLETED: 'UCS *{parcelCode} ne peut pas être complété dans SAP ME/MII',
    SAP_WORKORDER_CLOSED: "L'OF associé à l'UCS *{parcelCode} est fermé dans SAP MII",
    SAP_INTERNAL_ERROR: 'Erreur technique dans SAP MII',
    SAP_TIMEOUT_BUT_OK_AGGREGATION: "Timeout -> L'agrégation est OK",
    LVSP_PARCEL_NUMBER_ALREADY_AGGREGATED: 'Numéro UCS déjà agrégé dans LVSP',
    LVSP_SERIAL_ALREADY_AGGREGATED: 'Article scanné déjà agrégé dans un précédent numéro UCS',
    LVSP_MISMATCH_EXPECTED_QUANTITY: 'Quantité scanné différente de la quantité attendue dans LVSP',
    LVSP_SKU_NOT_FOUND: 'SKU inconnu dans LVSP',
    LVSP_SUPPLIER_NOT_FOUND: 'Atelier fournisseur inconnu dans LVSP',
    TECHNICAL_ERROR: 'Erreur Technique - Contactez le support via ContactIS',
    ERROR_IN_PARCEL_ITEMS:
      "Une erreur s'est produite lors de la confirmation du colis. Veuillez vider le colis en cliquant sur l'icône poubelle, puis scanner à nouveau tous les produits",
    product_is_authentic: 'Le produit est authentique',
    not_sellable: 'NON VENDABLE. Veuillez ouvrir un ticket NeoContact (à placer dans le bucket WDF).',
    stock_product:
      'PRODUIT EN STOCK: Conserver le produit comme étant vendable. RETOUR CLIENT: Acceptable pour un retour ou un échange, conserver le produit comme étant vendable.',
    store_action: 'Action',
    reprint: 'Réimpression',
    reprint_sent: 'Réimpression envoyée',
    longSKU: 'Long SKU',
    citesFlag: 'Cites',
    pairingDate: 'Production Date',
    pairingSupplier: 'Supplier',
    madeIn: 'Made in',
    batchNumber: 'Batch',
    status: 'Status',
    chrono: 'Chrono',
    logisticStatus: 'Product Status',
    serialNumber: 'RFID Serial Number',
    returnCode: 'Return Code',
    viewCitesDocument: 'View CITES Document',
    LV_LE_ERROR_ON_QUANTITY: 'La quantité de colis en édition limitée doit être de 1',
    LV_CUSTOM_DECODE_FAILED: 'LV tag decode failed'
  },
  imbustatrice: {
    and: ' et ',
    unkwon_tag: 'Étiquette inconnue',
    dynamic_tag: 'Étiquette {{role}}',
    dynamic_tag_missing: 'Étiquette {{role}} manquante',
    too_many_dynamic_tags: "Trop d'étiquettes {{role}}",
    dynamic_tag_already_associated: 'Étiquette {{role}} déjà associée',
    wrong_tag: 'Mauvaise étiquette',
    missing_tag: 'Étiquette manquante'
  },
  identifier_error: {
    ALREADY_ASSOCIATED_TAG: 'Déjà associée',
    TAG_ALREADY_ASSOCIATED_TO_WORKORDERROW: 'Étiquette déjà associée à une ligne de work order',
    WRONG_QC_STATUS: 'Statut de contrôle qualité incorrect',
    WRONG_QC_SIZE: 'Taille de contrôle qualité incorrecte',
    WRONG_QC_MODEL: 'Modèle de contrôle qualité incorrect',
    MISSING_MANDATORY_QC: 'Contrôle qualité manquant',
    MISSING_PRODUCT_INFO: 'Informations produit manquantes',
    WRONG_TAG: 'Mauvaise étiquette',
    UNKNOWN_TAG: 'Étiquette inconnue',
    WRONG_PRODUCT: 'Mauvais produit',
    MISSING_MANDATORY_TAG: 'Étiquette obligatoire manquante',
    MISSING_OPTIONAL_TAG: 'Étiquette optionnelle manquante',
    EXTRA_TAG: 'Étiquette en trop',
    TAG_MISMATCH: "Incohérence d'étiquette",
    PRODUCTIONORDERROW_MISMATCH: "Incohérence de l'association de ligne de commande de production",
    MISSING_SYSTEM_TAG: 'Étiquette système inconnue',
    UNEXPECTED_TAG: 'Étiquette inattendue',
    NOT_EXISTING_CERTILOGO_TAG: 'Certilogo code not present in the system',
    KILLED_TAG: 'Killed tag',
    MISSING_TAG: 'Missing tag',
    TOOL_DETECTED: 'Tool tag detected',
    TAG_NOT_PREENCODED: 'Tag non pré-encodé'
  },
  statuses: {
    RESTORE_VARIANT: 'RESTAURER LA TYPOLOGIE',
    CONFIRM_ERROR: 'ERREUR DE CONFIRMATION'
  },
  userSettings: {
    title: 'Paramètres utilisateur',
    autostopAntennaTimeout: "Arrêt automatique de l'antenne (ms)",
    autostartAntenna: "Démarrage automatique de l'antenne",
    autoConfirmParcel: 'Confirmation automatique du colis',
    barcodeItemRead: "Lecture d'articles à code-barres",
    antennas: 'Antennas settings',
    resetReadingsAfterOperation: 'Vitesse de réinitialisation après confirmation',
    slow: 'Lent',
    medium: 'Moyen',
    fast: 'Rapide',
    printerCode: "Code d'imprimante",
    enableOkSounds: 'Sons OK',
    enableKoSounds: 'Sons KO'
  },
  button: {
    submit: 'Envoyer',
    submitting: 'Envoi en cours...'
  },
  pre_encoding: {
    correct: 'Corriger',
    correction_title: 'Correction dessus',
    association_extra_right: 'Éloignez la chaussure droite du Pad et laissez uniquement la gauche',
    association_extra_left: 'Éloignez la chaussure gauche du Pad et laissez uniquement la droite',
    correction_instruction_right: 'Éloignez la chaussure droite du Pad et laissez uniquement la gauche posée',
    correction_instruction_left: 'Éloignez la chaussure gauche du Pad et laissez uniquement la droite posée',
    epc_reading: 'EPC: lecture en cours....',
    epc_label: 'EPC: {{epc}}',
    write_correction: 'Écrire la correction',
    correction_in_progress: 'Correction en cours...',
    correction_write_success: 'Correction terminée avec succès',
    correction_read_error: 'Lire un seul tag sur le Pad'
  }
}
